import { useCallback, useEffect, useRef } from 'react'

const useSyncRefs = (...refs) => {
  let cache = useRef(refs)

  useEffect(() => {
    cache.current = refs
  }, [refs])

  return useCallback(
    (value) => {
      if (import.meta.env.JEST_TEST && !Array.isArray(cache.current)) {
        return
      }
      for (let ref of cache.current) {
        if (!ref) continue
        if (typeof ref === 'function') ref(value)
        else ref.current = value
      }
    },
    [cache]
  )
}

export default useSyncRefs
